import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { clients, localStorageConstants, localStorageVariables } from 'src/app/core/localStorageConstants/localStorageConstants';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { EnvService } from 'src/app/core/services/env.service';
import { QuestionnaireInteractionService } from 'src/app/core/services/questionnaire-interaction.service';
import { InteractorService } from 'src/app/core/services/interactor.service';
import { LoginService } from 'src/app/core/services/login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationPageGuard implements CanActivate {

  public isChanged = false;
  redirectURL: any;

  constructor(private router: Router,
    private cookieService: CookieService,
    private localStorageService: LocalStorageService,
    private oauthService: OAuthService,
    private qiService: QuestionnaireInteractionService,
    public interactorService: InteractorService,
    private envService: EnvService,
    private activatedRoute: ActivatedRoute,
    private loginService: LoginService,

  ) {
    
  }

  canActivate(next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
    this.interactorService.setErrorFlag(false);
    this.qiService.valueChangesCast.subscribe((val) => {
      this.isChanged = val;
    });

    if (this.isChanged) {
      const obj = {
        confirm: true,
        route: state.url,
        triggerFrom: 'authenticationGuard'
      };
      this.qiService.setConfirmation(obj);
      return false;
    }
    if (this.localStorageService.getDataFromLocalStorage(localStorageVariables.token) ===
      '' || this.localStorageService.getDataFromLocalStorage(localStorageVariables.token) == null) {
      // this.router.navigateByUrl('');
      let redirect = window.location.href;
      //If OKTA deeplinking redirect to OKTA - PCIS-3204
      const client = sessionStorage.getItem('client');
      if (client) {
        redirect = redirect.replace('&client='+client, '');
        redirect = redirect.replace('?client='+client, '');
        sessionStorage.setItem('redirectUrl', redirect);
        sessionStorage.removeItem('client');
        
        // Handle different clients
        if (client === clients.cdss) {
          // Redirect to Okta authentication for CDSS
          window.location.href = '/auth/okta/sso';
        } else {
          // Use existing SSO configuration for other clients (like safy)
          this.loginService.getSSOConfigurations(client).subscribe((response: any) => {
            this.redirectURL = response?.Data?.redirectURL;
            window.location.href = this.redirectURL;
          }, err => {
            // Fallback to default logout if SSO configuration fails
            this.oauthService.logOut(false);
            this.oauthService.revokeTokenAndLogout();
            window.location.href = this.envService.logoutUrl;
          });
        }
      }
      else {
        this.oauthService.logOut(false);
        this.oauthService.revokeTokenAndLogout();
        window.location.href = this.envService.logoutUrl;
      }
      return false;
    } else {
      return true;
    }
  }

  findTenantAbbreviation() {

    const hostname = window && window.location.hostname && window.location.hostname;

    if (/^.*localhost.*/.test(hostname)) {
      return environment.tenantAbbreviation;
    } else {
      return hostname.split('.')[0]; // return subdomain as tenantAbbreviation
    }
  }
  
}